import { BackendService } from './backend.service';
var SupportService = (function () {
    function SupportService(backendService) {
        this.backendService = backendService;
    }
    SupportService.prototype.sendSupportMessage = function (subject, message) {
        return this.backendService.post("support", {
            subject: subject,
            message: message
        });
    };
    return SupportService;
}());
export { SupportService };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/services/support.service.ts.pre-build-optimizer.js